import Ext from 'Ext'
import View from '../../../View'
import _ from 'underscore'
import SharedUserButtonMenu from '../../../controls/selectorControls/at_shared_user_button_menu'
import GroupType from '../../../enums/GroupType'
import TwoLevelSelection from '../../../controls/selectorControls/two_level_selection'
import UsersSelectorPanel from '../../../usersSelector/at_users_selector_panel'
import SelectorPanelWithApplyButtonHelper from '../../../controls/selectorControls/at_selector_panel_with_apply_button_object'
import HierarchySelectorDropdownButton from '../../../controls/selectorControls/at_hierarchy_selector_dropdown_button'

export default class UsersFilter extends View {
    constructor({
        selectionCallback = ({all, userIds, groupIds, groupType}) => {},
    }) {
        super()

        this.selectionCallback = selectionCallback

        this.state = {
            disabled: false,
            userIds: [],
            groupIds: [],
            groupType: GroupType.USER_GROUP,
            all: false,
            users: [],
            userGroups: [],
            timeZoneGroups: [],
            ugrEnabled: true,
            tzgEnabled: true,
        }

        this.onAnyStatePropertyDeeplyChanged(
            [
                'all',
                'userIds',
                'groupIds',
                'groupType',
                'ugrEnabled',
                'userGroups',
                'tzgEnabled',
                'timeZoneGroups',
            ],
            () => {
                this._initPanel()
            }
        )

        this.onStatePropertyChanged('disabled', (disabled) => {
            this.chooseUserButton.setEnabled(!disabled)
        })
    }

    showAt($el, position) {
        this.menu.show($el[0], position)
    }

    hide() {
        this.menu.hide()
    }

    _handleSelectionChanged = (data) => {
        this.selectionCallback(data)
    }

    _initPanel() {
        const PanelCtr = UsersSelectorPanel
        const ctrParams = {}
        Ext.apply(ctrParams, SelectorPanelWithApplyButtonHelper.getApplyButtonExtension(PanelCtr))
        const panel = new PanelCtr({
            ...ctrParams,
            onCloseButtonClick: () => {
                UsersSelectorPanel.superclass.onCloseButtonClick.call(panel)

                const result = {
                    all: !panel.isCustomOptionSelected(),
                    userIds: panel.getSelection().getSecondLevel(),
                    groupIds: panel.getSelection().getFirstLevel(),
                    groupType: panel.getGroupType(),
                }
                this._handleSelectionChanged(result)
            },
            allItemsOptionLabelKey: 'dar_settings.users_filter.all_staff',
            customOptionLabelKey: 'dar_settings.users_filter.selected_staff',
        })
        panel.initialize(
            this.state.ugrEnabled,
            this.state.tzgEnabled,
            this.state.users,
            this.state.userGroups,
            this.state.timeZoneGroups
        )
        panel.loadState({
            selection: new TwoLevelSelection(this.state.groupIds, this.state.userIds),
            groupType: this.state.groupType,
            additionalCheckBoxValue: false,
            optionValue: this.state.all,
            showInactive: false
        })

        // if button not exists or linked menu already not actual - create new button and link with actual menu
        if (this.chooseUserButton) {
            this.chooseUserButton.menu = null // because ext.js cannot destroy menu without problems
            this.chooseUserButton.destroy() // delete prev button
        }
        this.chooseUserButton = new HierarchySelectorDropdownButton({
            renderTo: this.$containerEl[0],
            menu: new SharedUserButtonMenu({
                panel,
                additionalCls: 'darSettings_components_usersFilter_menu'
            }),
        })
        this.chooseUserButton.updateButton()
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/darSettings/components/UsersFilter.js